import { ECheckedValue } from "library/types";

export const APP_ID = 900000001200518;
export const APP_SETTING_ID = 900000000010304;

export const breakpoints = {
  xs: 320,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
};

export const devices = {
  xs: `(min-width: ${breakpoints.xs}px)`,
  sm: `(min-width: ${breakpoints.sm}px)`,
  md: `(min-width: ${breakpoints.md}px)`,
  lg: `(min-width: ${breakpoints.lg}px)`,
  xl: `(min-width: ${breakpoints.xl}px)`,
  "2xl": `(min-width: ${breakpoints["2xl"]}px)`,
};

export const checkedOptions = [
  {
    value: ECheckedValue.Yes,
    label: "Yes",
    text: "Yes",
  },
  {
    value: ECheckedValue.No,
    label: "No",
    text: "No",
  },
];

export const LOCATION_STATES = {
  PREV_PATH_NAME: "previousLocationPathname",
};

export const hexColorPalette = [
  "#000000",
  "#333333",
  "#666666",
  "#999999",
  "#CCCCCC",
  "#FFFFFF", // Grayscale
  "#FF0000",
  "#FF4500",
  "#DC143C",
  "#C71585",
  "#FF1493",
  "#FF69B4", // Reds & Pinks
  "#FF8C00",
  "#FFA500",
  "#FFD700",
  "#FFFF00",
  "#9ACD32",
  "#ADFF2F", // Oranges & Yellows
  "#008000",
  "#006400",
  "#00FF00",
  "#7FFF00",
  "#32CD32",
  "#00FA9A", // Greens
  "#40E0D0",
  "#20B2AA",
  "#00CED1",
  "#4682B4",
  "#1E90FF",
  "#0000FF", // Teals & Blues
  "#00008B",
  "#4B0082",
  "#8A2BE2",
  "#9370DB",
  "#9932CC",
  "#9400D3", // Purples
  "#8B0000",
  "#A52A2A",
  "#D2691E",
  "#CD853F",
  "#DEB887",
  "#F5DEB3", // Browns & Earth Tones
  "#FAEBD7",
  "#FFE4C4",
  "#FFDEAD",
  "#FFDAB9",
  "#EEE8AA",
  "#F0E68C", // Light Pastels
  "#E6E6FA",
  "#DDA0DD",
  "#D8BFD8",
  "#FFC0CB", // Soft Colors
];
